<template>
  <v-card>
    <v-card-title class="title text-capitalize justify-center">
      {{ document.title ? document.title.replaceAll("_", " ") : "" }}
    </v-card-title>
    <v-card-title class="body-2 text-capitalize justify-center pt-0">
      {{ document.creationTime }}
    </v-card-title>
    <div
      class="d-flex flex-wrap justify-center align-center pt-1 px-1"
      style="margin-top: 5px"
    >
      <v-chip
        v-for="(item, i) in document.categories"
        :key="i"
        class="mx-1"
        small
        color="#e0e0e0"
        :text-color="
          selectedCategories.includes(item.key) ? '#000' : 'rgba(0, 0, 0, 0.3)'
        "
        @click="toggleTag(item.key)"
        >{{ item.text }}</v-chip
      >
    </div>
    <v-card-text class="pa-8">
      <doc-sentence
        v-for="(s, index) in document.sentences"
        :key="index"
        :sentence="s.sent"
        :highlight="selectedCategories.includes(s.category)"
      >
      </doc-sentence>
    </v-card-text>
  </v-card>
</template>

<script>
import { getCategoryDisplayName } from "@/commons/util.js";
import DocSentence from "@/components/datasets/DocSentence.vue";

export default {
  data() {
    return {
      document: {
        creationTime: undefined,
        title: undefined,
        sentences: [],
        categories: [],
      },
      selectedCategories: [],
    };
  },
  components: {
    DocSentence,
  },
  mounted() {
    this.loadDocument();
  },
  methods: {
    loadDocument() {
      this.$http
        .get(`/api/datasets/${this.datasetUid}/documents/${this.documentUid}`)
        .then((response) => {
          console.log(response.data);
          this.document.creationTime = response.data.creation_time;
          this.document.title = response.data.title;
          this.document.sentences = response.data.metadata.sentences;
          this.document.categories = response.data.metadata.categories_as_labels.map(
            (entry) => {
              return {
                key: entry,
                text: getCategoryDisplayName(entry),
              };
            }
          );
        });
    },
    toggleTag(key) {
      if (this.selectedCategories.includes(key)) {
        const index = this.selectedCategories.indexOf(key);
        this.selectedCategories.splice(index, 1);
      } else {
        this.selectedCategories.push(key);
      }
    },
  },
  computed: {
    datasetUid() {
      return this.$route.params.datasetUid || "";
    },
    documentUid() {
      return this.$route.params.documentUid || "";
    },
  },
};
</script>

<style>
</style>